import { render, staticRenderFns } from "./search-consent-register.vue?vue&type=template&id=10deb4ea&scoped=true&"
import script from "./search-consent-register.vue?vue&type=script&lang=js&"
export * from "./search-consent-register.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10deb4ea",
  null
  
)

export default component.exports